export default "__VITE_ASSET__BFQDAgAa__"